import { EntityTypes } from 'constants/entities';
import { restoreState } from 'core/actions/product/state';
import { removeVideo } from 'core/sagas/player/video';
import { updatePlayerState } from 'core/slices/player';
import { exit } from 'core/slices/register';
import { all, fork, takeEvery, call, put } from 'redux-saga/effects';

export function* exitSaga() {
  yield all([
    put(yield call(updatePlayerState, { paused: true, culprit: 'exitSaga' })),
    removeVideo(),
    put(
      yield call(restoreState, [
        { type: EntityTypes.SCENE, id: null },
        { type: EntityTypes.ACTION, id: null },
        { type: EntityTypes.MODULE, id: null },
        { type: EntityTypes.SESSION_ATTEMPT, id: null },
        { type: EntityTypes.COURSE_PROGRESS, id: null },
      ]),
    ),
  ]);
}

export function* watchExit() {
  yield takeEvery(exit, exitSaga);
}

export function* closeSaga() {
  yield all([fork(watchExit)]);
}
